import React from 'react';
import cn from 'classnames';
import Card, { CardHeader } from '../../../../components/Card';
import styles from './InnerCard.module.scss';

const InnerCard = ({ className, action, title, children, dark = false }) => {
  return (
    <Card className={cn(styles.root, className)} dark={dark}>
      {(title || action) && (
        <CardHeader
          title={title}
          action={action}
          titleProps={{ className: styles.title }}
        />
      )}
      {children}
    </Card>
  );
};

export default InnerCard;
